import { combineReducers } from 'redux';

import { createGenericReducer as createReducer } from '../../services/create-reducer';
import { SET_TOTAL_MEMBERS_COUNT, SET_MEMBER_IDS, SET_IS_LOADING, SET_CURSOR, SET_HAS_NEXT } from './actions';

const getPayload = (a) => a.payload;

const reduceToPayload = (actionType) => ({ [actionType]: getPayload });

export default combineReducers({
  pageType: createReducer(null, {}),
  isLoading: createReducer(false, reduceToPayload(SET_IS_LOADING)),
  memberIds: createReducer([], reduceToPayload(SET_MEMBER_IDS)),
  totalMembersCount: createReducer(0, reduceToPayload(SET_TOTAL_MEMBERS_COUNT)),
  cursor: createReducer('', reduceToPayload(SET_CURSOR)),
  hasNext: createReducer(false, reduceToPayload(SET_HAS_NEXT)),
});
